import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'
import {GetMessagingConversationIdUserRequest} from '../Requests/GetMessagingConversationIdUserRequest.js'

class GetMessagingConversationIdUserUseCase extends UseCase {
  #config
  #repository

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  static create({config}) {
    return new GetMessagingConversationIdUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })
  }

  @tracer({metric: 'GetMessagingConversationIdUserUseCase#execute'})
  @AsyncInlineError()
  async execute({entityType = 'AD', entityId, buyerId, sellerId, isProfessionalSeller = false}) {
    const request = GetMessagingConversationIdUserRequest.create({
      entityType,
      entityId,
      buyerId,
      sellerId,
      isProfessionalSeller
    })

    const [error, conversationId] = await this.#repository.getMessagingConversationId({
      messagingConversationIdUserRequest: request
    })

    if (error) {
      return Promise.reject(error)
    }

    return conversationId.toJSON()
  }
}

export const factory = GetMessagingConversationIdUserUseCase.create
